exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".vehicle-link[data-v-484e4508]{text-decoration:none;border-bottom:1px dashed transparent;transition:all .2s;cursor:pointer}.vehicle-link[data-v-484e4508]:hover{text-decoration:none!important;border-bottom-color:#3b82f6;opacity:.8}.custom-table[data-v-484e4508]{background:#fff}.location-click[data-v-484e4508]{cursor:pointer;transition:opacity .2s}.location-click[data-v-484e4508]:hover{opacity:.7}.location-text[data-v-484e4508]:hover{text-decoration:underline}.trip-assign-link[data-v-484e4508]{text-decoration:none;border-bottom:1px dashed rgba(0,123,255,.35);cursor:pointer}.trip-assign-link[data-v-484e4508]:hover{text-decoration:none;border-bottom-color:#007bff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-484e4508","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/dashboard/VehiclePerformanceDashboard/components/UtilizationTab.vue
// module id = 1567
// module chunks = 0